import React, { useEffect, useState } from "react";
import axiosInstance from "../Utils/axiosInstance";
import { toast } from "react-toastify";

const History = () => {
  const [bets, setBets] = useState([]);
  const [filter, setFilter] = useState("pending");
  const [loading, setLoading] = useState(false);
  const backUrl = process.env.REACT_APP_BACKEND_URL;

  const fetchBetHistory = async () => {
    try {
      const res = await axiosInstance.get(`${backUrl}/api/bet-game-history`);
      setBets(res?.data?.bets || []);
    } catch (error) {
      console.error("Error fetching bet history:", error);
    }
  };

  useEffect(() => {
    fetchBetHistory();
  }, [backUrl]);

  const handleDeleteBet = async (betId) => {
    if (!window.confirm("Are you sure you want to delete this bet?")) {
      return;
    }

    setLoading(true);
    try {
      const res = await axiosInstance.post(`${backUrl}/api/delete-bet`, {
        betId: betId,
      });

      if (res.data.success) {
        toast.success(res.data.message);
        fetchBetHistory(); // Refresh bet list
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to delete bet");
    } finally {
      setLoading(false);
    }
  };

  const filteredBets =
    filter === "pending"
      ? bets.filter((b) => !b.status)
      : bets.filter((b) => b.status);

      const formatIST = (dateString) => {
  return new Date(dateString.replace(" ", "T")).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};


  return (
    <div>
      <div className="bg-white p-3 rounded shadow-sm">
        <div className="d-flex justify-content-between flex-wrap gap-3">
          <div className="flex-fill text-center">
            <button
              className={`w-full py-2 px-4 rounded ${
                filter === "pending"
                  ? "bg-black text-white"
                  : "bg-white text-black border border-gray-300"
              }`}
              onClick={() => setFilter("pending")}
            >
              Pending Bet
            </button>
            <p className="mt-2 small border border-danger text-danger p-2 rounded">
              जिन गेम का रिजल्ट नही आया वो PENDING BET में दिखेंगी।
            </p>
          </div>

          <div className="flex-fill text-center">
            <button
              className={`w-full py-2 px-4 rounded ${
                filter === "declared"
                  ? "bg-black text-white"
                  : "bg-white text-black border border-gray-300"
              }`}
              onClick={() => setFilter("declared")}
            >
              Declared Bet
            </button>
            <p className="mt-2 small border border-danger text-danger p-2 rounded">
              जिन गेम का रिजल्ट आ गया है वो DECLARED BET में दिखेंगी।
            </p>
          </div>
        </div>

        <div className="table-responsive mt-3">
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Date</th>
                <th>Name</th>
                <th>Type</th>
                <th>Number</th>
                <th>Points</th>
                <th className="grid">
                  <span className="text-[10px]">(Bet type)</span>Result
                </th>
                <th>Win_amount</th>
                <th>Status</th>
                {filter === "pending" && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {filteredBets.length > 0 ? (
                filteredBets.map((bet, index) => (
                  <tr key={bet.id}>
                    <td>{index + 1}</td>
                    <td>
                   {formatIST(bet.date_time)}
                    </td>
                    <td>{bet.game}</td>
                    <td>{bet.type}</td>
                    <td>{bet.number}</td>
                    <td>{bet.point}</td>
                    <td>{bet.result ? bet?.result : "-"}</td>
                    <td>{bet.win_amount}</td>
                    <td>
                      {bet.status ? (
                        <span
                          className={`badge ${
                            bet.status === "Win" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {bet.status}
                        </span>
                      ) : (
                        <span className="badge bg-warning text-dark">
                          Pending
                        </span>
                      )}
                    </td>
                    {filter === "pending" && (
                      <td>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDeleteBet(bet.id)}
                          disabled={loading}
                        >
                          {loading ? "..." : "Edit"}
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={filter === "pending" ? "10" : "9"} className="text-center">
                    No {filter} bets found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default History;
